/**
 * Attachments (Spec 11 + ADR 0005).
 *
 * Ablauf: Datei hochladen → `attachment_id` → beim Anlegen einer Nachricht
 * referenzieren. Freie (noch nicht referenzierte) Attachments gehoeren dem
 * hochladenden Mitglied.
 *
 * Der Download laeuft ueber eine **signierte, ablaufende URL** — die Datei
 * liegt ausserhalb des Web-Roots unter `DATA_DIR/attachments/<tenant>/<uuid>`.
 */
import { z } from 'zod';
import { uuidSchema } from './common.js';
/** 25 MB — dieselbe Grenze, die der SMTP-Empfaenger ab Phase 2 setzt (Spec 6.1.1). */
export const ATTACHMENT_MAX_BYTES = 25 * 1024 * 1024;
/** Gueltigkeit einer signierten Download-URL. */
export const ATTACHMENT_URL_TTL_SECONDS = 5 * 60;
export const allowedFileTypeSchema = z.object({
    id: uuidSchema,
    tenant_id: uuidSchema,
    /** Kleingeschrieben, ohne Punkt: `png`, `pdf`. */
    extension: z
        .string()
        .min(1)
        .max(16)
        .regex(/^[a-z0-9]+$/, 'Nur Kleinbuchstaben und Ziffern.'),
    mime: z.string().min(3).max(128),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
});
/** Seed aus Spec 11 — im Backend je Mandant erweiterbar. */
export const DEFAULT_ALLOWED_FILE_TYPES = [
    { extension: 'png', mime: 'image/png' },
    { extension: 'jpg', mime: 'image/jpeg' },
    { extension: 'jpeg', mime: 'image/jpeg' },
    { extension: 'webp', mime: 'image/webp' },
    { extension: 'gif', mime: 'image/gif' },
    { extension: 'pdf', mime: 'application/pdf' },
];
export const createAllowedFileTypeSchema = allowedFileTypeSchema.pick({
    extension: true,
    mime: true,
});
export const attachmentSchema = z.object({
    id: uuidSchema,
    tenant_id: uuidSchema,
    ticket_message_id: uuidSchema.nullable(),
    filename: z.string().min(1).max(255),
    mime: z.string().min(3).max(128),
    size: z.number().int().min(0),
    sha256: z.string().length(64),
    /** Signiert und zeitlich begrenzt (`ATTACHMENT_URL_TTL_SECONDS`). */
    download_url: z.string().min(1),
    created_at: z.iso.datetime(),
});
//# sourceMappingURL=attachment.js.map